import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
    DeleteRecord,
    GetListview,
    SuccessAlert,
    URLPRIFIX,
    ErrorAlert,
    GetStatusCounts,
    GetRecords,
    UpdateRecord
} from "../../../functions/api";
import { useStore } from "../../../Components/StateProvider";
import Pagination from "../../../Components/Fields/Pagination"; // Ensure this import is used if Pagination component is part of your UI
import { getlocal } from "../../../functions/localstorage";
import StatusTabs from "../../../Components/Elements/StatusTabs";
import ListViewUp from "../../../Components/Elements/ListViewUp";
import BulkActionsBar from "../../../Components/Elements/BulkActionsBar";
import BulkUpdateModal from "../../../Components/Elements/BulkUpdateModal";

const TTask_AssignedUpd = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const user = getlocal("system")?.user || {};

    const { id } = useParams();
    const [activeTab, setActiveTab] = useState("ALL");
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [statusTabs, setStatusTabs] = useState([]);
    const [users, setUsers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hasTabClicked, setHasTabClicked] = useState(false);
    const tablename = "trademark/tasks";
    const tableURL = "/subtask/getsubtasklistbyType/13";
    const DeleteURL = "/subtask/deletesubtask/";
   const statusCountURL = "/subtask/getprojectsubtaskstatuscount/13/"+user.id;
    const getDynamicTableURL = () => {
        return user.role === 1 ? tableURL : tableURL + "/" + user.id;
    };

    const [filters, setFilters] = useState({});
    const [sortConfig, setSortConfig] = useState({
        field: "",
        direction: "asc",
    });

    const Tablehead = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ";
    const Tablerecord = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden";
    const width = "100%";
    const height = "90%";

    const Header = [
      ["Task Title", "subtask_title"],
    ["Project Name", "project_name"],
    ["Priority", "priority"],
    ["Status", "status"],
    ["Due Date", "dueDate"],
    ["Created Date", "createdDate"],
    ["Action", "ACTION"],
    ];
    const Header1 = [
        ["Task Title", "subtask_title"],
        ["Description", "description"],
        ["Priority", "priority"],
        ["Status", "status"],
        ["Assigned To", "assigned_to_username"],
        ["Due Date", "dueDate"],
        ["Action", "ACTION"],
    ];
    const store = useStore();
    const init = {
        filterfield: "all",
        search: "",
        sort: "desc",
        currentpage: 1,
        totalpage: 1,
        pagesize: 20,
    };


    const loadListview = useCallback((params = {}) => {
        // Ensure loadListview uses the derived filter parameters for the API call
        GetListview({
            listUrl: getDynamicTableURL(),
            store,
            field: params.field ?? store.getvalue("taskfilterfield") ?? init.filterfield,
            search: params.search ?? store.getvalue("tasksearch") ?? init.search,
            sort: params.sort ?? store.getvalue("tasksort") ?? init.sort,
            page: params.page ?? store.getvalue("taskCurrentPage") ?? init.currentpage,
            pagesize: params.pagesize ?? store.getvalue("taskpagesize") ?? init.pagesize,
        });
    }, [store, getDynamicTableURL]);

    useEffect(() => {
        store.setmodule("trademark_tasks", init).then(() => {
            fetchStatusCounts();
            store.setheader(`${tablename} List`);

            store.stopLoading();

            // Get stored values
            const storedFilters = store.getvalue("taskFilters");
            const storedField = queryParams.get("field") || store.getvalue("taskfilterfield") || "all";
            const storedSearch = queryParams.get("search") || store.getvalue("tasksearch") || "";
            const storedSort = queryParams.get("sort") || store.getvalue("tasksort") || "desc";
            const storedPage = store.getvalue("taskCurrentPage") || 1;
            const storedPageSize = store.getvalue("taskpagesize") || 20;
            const storedTab = store.getvalue("taskActiveTab") || "ALL";

            // Restore UI state
            if (storedFilters) setFilters(storedFilters);
            setActiveTab(storedTab);
            setHasTabClicked(true); // Prevent future reloads if tab is clicked again

            // Apply filters to reload the list
            change({
                field: storedField,
                search: storedSearch,
                sort: storedSort,
                page: storedPage,
                pagesize: storedPageSize,
            });
        });
    }, []);





    const change = useCallback((props) => {

        // Construct updatedFilters based on the new props and current filters
        const updatedFilters = props.field ? { ...filters, [props.field]: props.search } : {};

        setFilters(updatedFilters);
        store.setvalue("taskFilters", updatedFilters);
        store.setvalue("taskFilters", { [props.field]: props.search });
        store.setvalue("taskfilterfield", props.field);
        store.setvalue("tasksearch", props.search);
        store.setvalue("tasksort", props.sort);
        store.setvalue("taskCurrentPage", props.page);
        store.setvalue("taskpagesize", props.pagesize);


        // store.setvalue("taskfilterfield", props.field || "all");
        // store.setvalue("tasksearch", props.search || "");
        // store.setvalue("tasksort", props.sort || init.sort);
        // store.setvalue("taskpagesize", props.pagesize || store.getvalue("taskdefaultpagesize"));

        loadListview({
            field: props.field,
            search: props.search,
            sort: props.sort,
            page: props.page || 1, // Pass page explicitly
            pagesize: props.pagesize,
        });
    }, [filters, store, loadListview]);

    function onpage(page, pagesize = store.getvalue("taskpagesize")) {
        store.setvalue("taskCurrentPage", page);
        // When navigating pages, retain existing filter and sort.
        loadListview({
            field: store.getvalue("taskfilterfield"),
            search: store.getvalue("tasksearch"),
            sort: store.getvalue("tasksort"),
            page,
            pagesize,
        });
    }

    const fetchStatusCounts = useCallback(async () => {
        store.startLoading();
        try {
            const counts = await GetStatusCounts(statusCountURL, store);
            if (counts?.statuscount) {
                setStatusTabs(counts.statuscount);
            }
        } catch {
            ErrorAlert("Failed to fetch status counts.");
        } finally {
            store.stopLoading();
        }
    }, []);

    const handleFilterChange = useCallback((label, value) => {
        const updatedFilters = { ...filters, [label]: value };
        setFilters(updatedFilters);
        change({
            field: label,
            search: value,
            pagesize: store.getvalue("documentPageSize"),
            sort: sortConfig.direction,
        });
    }, [filters, sortConfig]);
    // const statusTabs = store.getvalue("statuscount") || [];

    // Handler for individual and "select all" checkboxes
    const handleOnSelect = (itemOrItems, isChecked) => {
        if (Array.isArray(itemOrItems)) {
            // This is for "Select All"
            if (isChecked) {
                setSelectedRecords([...itemOrItems]); // Select all visible filtered records
            } else {
                setSelectedRecords([]); // Deselect all
            }
        } else {
            // This is for individual row selection
            if (isChecked) {
                setSelectedRecords((prevSelected) => [...prevSelected, itemOrItems]);
            } else {
                setSelectedRecords((prevSelected) =>
                    prevSelected.filter((record) => record.id !== itemOrItems.id)
                );
            }
        }
    };

    // Handler for bulk assign action
    const handleBulkAssignold = (itemsToAssign) => {
        console.log("Bulk Assign these items:", itemsToAssign);
        alert(`Assigning ${itemsToAssign.length} items! (Implement API call here)`);
        // After successful API call for bulk assign:
        setSelectedRecords([]);
        GetListview({
            listUrl: getDynamicTableURL(), // Use dynamic URL here
            store: store,
            field: store.getvalue("taskfilterfield"),
            search: store.getvalue("tasksearch"),
            sort: store.getvalue("tasksort"),
            page: store.getvalue("taskCurrentPage"),
            pagesize: store.getvalue("taskpagesize"),
        });
    };
    const fetchUsers = useCallback(async () => {
        try {
            const response = await GetRecords("/users/getusers?fieldname=all&sort=asc&page=1&count=10&pagesize=1000");
            if (response?.record?.list?.length) {
                setUsers(response.record.list);
            }
        } catch { }
    }, []);
    const handleBulkAssign = useCallback(() => {
        setIsModalOpen(true);
        fetchUsers();
    }, []);

    const handleBulkAssignUpdate = useCallback(async (assignedToId) => {
        store.startLoading();
        try {
            const taskIds = selectedRecords.map((item) => item.id);
            const payload = {
                task_ids: taskIds,
                assigned_to: assignedToId.assignedTo,
                modified_by: store.getuser().id,
                ...(assignedToId.due_date && { due_date: assignedToId.due_date }),
            };

            const res = await UpdateRecord("/subtasks/bulkupdatedocuments/11", payload);
            if (res?.success) {
                SuccessAlert("Selected items assigned successfully!");
            } else {
                ErrorAlert(res?.errorMessage || "Bulk update failed.");
            }
        } catch (error) {
            ErrorAlert(`Bulk update failed: ${error.message}`);
        } finally {
            setIsModalOpen(false);
            setSelectedRecords([]);
            loadListview();
            store.stopLoading();
        }
    }, [selectedRecords]);

    const handleBulkApprove = (itemsToAssign) => {
        console.log("Bulk Assign these items:", itemsToAssign);
        alert(`Assigning ${itemsToAssign.length} items! (Implement API call here)`);
        // After successful API call for bulk assign:
        setSelectedRecords([]);
        GetListview({
            listUrl: getDynamicTableURL(), // Use dynamic URL here
            store: store,
            field: store.getvalue("taskfilterfield"),
            search: store.getvalue("tasksearch"),
            sort: store.getvalue("tasksort"),
            page: store.getvalue("taskCurrentPage"),
            pagesize: store.getvalue("taskpagesize"),
        });
    };

    // Handler for bulk delete action
    const handleBulkDelete = async (itemsToDelete) => {
        console.log("Bulk Delete these items:", itemsToDelete);
        store.startLoading(); // Show loading indicator

        let allSuccess = true;
        for (const item of itemsToDelete) {
            try {
                const res = await DeleteRecord(DeleteURL + item.id, {
                    modifiedBy: store.getuser().id,
                });
                if (!res.success) {
                    allSuccess = false;
                    ErrorAlert(
                        res?.errormessage?.response?.data ||
                        `Error deleting item ${item.id}. Please contact the Admin.`
                    );
                }
            } catch (error) {
                allSuccess = false;
                ErrorAlert(`Error deleting item ${item.id}: ${error.message}`);
            }
        }

        if (allSuccess) {
            SuccessAlert("Selected items deleted successfully!");
        } else {
            ErrorAlert("Some items could not be deleted. Check console for details.");
        }

        setSelectedRecords([]); // Clear selection
        GetListview({
            listUrl: getDynamicTableURL(), // Use dynamic URL here
            store: store,
            field: store.getvalue("taskfilterfield"),
            search: store.getvalue("tasksearch"),
            sort: store.getvalue("tasksort"),
            page: store.getvalue("taskCurrentPage"),
            pagesize: store.getvalue("taskpagesize"),
        });
        store.stopLoading(); // Hide loading indicator
    };


    // Modified handleClickRow to ONLY redirect to view page if 'view' permission is available
    const handleClickRow = (item) => {
        console.log("Row clicked:", item);
        if (store.getprops("view")) { // Only redirect to view if permission is true
            store.navTo(`/${URLPRIFIX}/${tablename}/view/${item.id}`);
        }
        // No 'else if (store.getprops("update"))' here, so no redirect to edit from row click
    };

    // ListView's internal logic and rendering starts here
    const handleSort = useCallback((label) => {
        const direction = sortConfig.field === label && sortConfig.direction === "asc" ? "desc" : "asc";
        setSortConfig({ field: label, direction });
        // Trigger a change to reload list with new sort config
        change({
            field: store.getvalue("taskfilterfield"), // Retain current filter field
            search: store.getvalue("tasksearch"), // Retain current search term
            sort: direction,
            pagesize: store.getvalue("taskpagesize"), // Retain current page size
            page: 1, // Reset to first page on sort change
        });
    }, [sortConfig, change, store]);

    const records = store.getvalue("list") || []; // Get records from the store

    const filteredRecords = records
        .filter((record) => {
            const upper = activeTab.toUpperCase();
            // Apply tab-specific filtering before general filters
            if (upper !== "ALL" && upper !== "ASSIGNED" && upper !== "UNASSIGNED") {
                if (record.status?.toUpperCase() !== upper) return false;
            }
            if (upper === "ASSIGNED" && !record.assigned_to) return false;
            if (upper === "UNASSIGNED" && record.assigned_to) return false;

            // Apply general filters
            return Header.every(([_, label]) => {
                const filterValue = filters[label];
                if (!filterValue) return true;

                let fieldValue = record[label];
                if (label.toLowerCase().includes("date") && fieldValue) {
                    const parsed = new Date(fieldValue);
                    if (!isNaN(parsed)) fieldValue = parsed.toISOString().split("T")[0];
                }
                return (
                    fieldValue &&
                    fieldValue.toString().toLowerCase().includes(filterValue.toLowerCase())
                );
            });
        })
        .sort((a, b) => {
            const { field, direction } = sortConfig;
            if (!field) return 0;

            const aVal = (a[field] ?? "").toString().toLowerCase();
            const bVal = (b[field] ?? "").toString().toLowerCase();

            if (aVal < bVal) return direction === "asc" ? -1 : 1;
            if (aVal > bVal) return direction === "asc" ? 1 : -1;
            return 0;
        });


    const handleSelectAll = (event) => {
        if (event.target.checked) {
            handleOnSelect(filteredRecords, true); // Select all visible records
        } else {
            handleOnSelect([], false); // Deselect all
        }
    };

    const isAllSelected =
        filteredRecords.length > 0 &&
        selectedRecords.length === filteredRecords.length &&
        filteredRecords.every((record) =>
            selectedRecords.some((sItem) => sItem.id === record.id)
        );

    const isSelected = (item) => selectedRecords.some((sItem) => sItem.id === item.id);

    const handleTabClick = useCallback((status, count) => {
        const upper = status.toUpperCase();
        store.startLoading();
        setActiveTab(status);
        setHasTabClicked(true);
        store.setvalue("taskActiveTab", status);
        store.setvalue("taskTabClicked", true);

        // Determine field and search based on the clicked tab
        const field = upper === "ASSIGNED" || upper === "UNASSIGNED" ? "assigned_to" : "status";
        const search =
            upper === "ALL" ? "" : upper === "ASSIGNED" ? "gt:0" : upper === "UNASSIGNED" ? "eq:0" : upper;

        // Update filters state and store for consistency
        const filterValue = upper === "ALL" ? {} : { [field]: search };
        setFilters(filterValue);
        store.setvalue("taskFilters", filterValue);

        // Adjust pagesize based on count if necessary, or revert to default for "ALL"
        const pageSize = count || init.pagesize; // Use count if available, otherwise default
        store.setvalue("taskpagesize", pageSize);

        // Trigger the change function to load data with the new filters
        change({ field, search, pagesize: pageSize, sort: store.getvalue("tasksort"), page: 1 }); // Reset to page 1

        setTimeout(() => {
            store.stopLoading();
        }, 200);
    }, [store, change, init.pagesize]);


    const handleClearFilter = useCallback(() => {
        setActiveTab("ALL");
        setFilters({});
        setHasTabClicked(false);
        store.setvalue("taskFilters", {});
        store.setvalue("taskpagesize", init.pagesize);
        store.setvalue("taskfilterfield", init.filterfield);
        store.setvalue("tasksearch", init.search);
        store.setvalue("tasksort", init.sort);
        store.setvalue("taskCurrentPage", init.currentpage);
        store.setvalue("taskActiveTab", "ALL");
        store.setvalue("taskTabClicked", false);
        loadListview({ ...init }); // Reload with initial state
    }, [store, loadListview, init]);

    const handleDelete = useCallback(async (item) => {
        if (!window.confirm("Are you sure you want to delete?")) return;
        store.startLoading();
        try {
            const res = await DeleteRecord(`${DeleteURL}${item.id}`, {
                modifiedBy: store.getuser().id,
            });
            if (res.success) {
                SuccessAlert("Deleted Successfully");
                setSelectedRecords((prev) => prev.filter((r) => r.id !== item.id));
                loadListview();
                fetchStatusCounts();
            } else {
                ErrorAlert("Error Found. Please contact the Admin.");
            }
        } catch (error) {
            ErrorAlert(`Error deleting item: ${error.message}`);
        } finally {
            store.stopLoading();
        }
    }, []);


    return (
        <div className="grid grid-rows-10 h-full">
            <div className="flex flex-wrap justify-between items-center mb-2 px-2">
                <div className="flex-1 overflow-x-auto">
                    <StatusTabs
                        statusTabs={statusTabs}
                        activeTab={activeTab}
                        onTabClick={handleTabClick}
                        hasTabClicked={hasTabClicked}
                        onClearClick={handleClearFilter}
                    />
                </div>
                {store.getprops("add") && (
                    <button
                        className="bg-primary text-secondary px-3 py-1 rounded-full border-2 transition text-sm whitespace-nowrap"
                        onClick={() => {
                            store.removemodule("nonlitigation_task"); // Original module name was 'nonlitigation_document'
                            store.navTo("/demo/" + tablename + "/create"); // Original navTo path was different
                        }}
                    >
                        ➕ ADD NEW
                    </button>
                )}
            </div>

            <div className="row-span-9 h-full w-full">
                <div
                    className="py-5 px-[30px] h-full w-full"
                    contentEditable={false}
                >
                    {/* Integrated ListView Table Structure */}
                    <ListViewUp
                        header={Header}
                        filteredRecords={filteredRecords}
                        Tablehead={Tablehead}
                        Tablerecord={Tablerecord}
                        sortConfig={sortConfig}
                        handleSort={handleSort}
                        filters={filters}
                        onFilterChange={handleFilterChange}
                        store={store}
                        handleOnSelect={handleOnSelect}
                        isSelected={isSelected}
                        handleClickRow={handleClickRow}
                        handleDelete={handleDelete}
                        handleSelectAll={handleSelectAll}
                        isAllSelected={isAllSelected}
                        tablename={tablename}

                    />
                    <BulkActionsBar
                        selectedRecords={selectedRecords}
                        store={store}
                        // onBulkAssign={handleBulkAssign}
                        // onBulkDelete={() => handleBulkDelete(selectedRecords)}
                    />
                    {/* <BulkUpdateModal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        onUpdate={handleBulkAssignUpdate}
                        users={users}
                    /> */}
                    {/* Bulk Action Buttons - Styled as tabs */}
                    {/* {selectedRecords.length > 0 && (
                        <div className="absolute bottom-4 left-4 flex gap-1 p-2 bg-white text-black shadow-xl rounded-md">
                            <span className="text-sm px-3 py-1  mr-2 flex items-center">
                                {selectedRecords.length} items selected
                            </span>
                            {store.getprops("update") && ( // Assuming bulk assign needs update permission
                                <button
                                    className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
                                    onClick={() => handleBulkAssign(selectedRecords)}
                                >
                                    To Assign
                                </button>
                            )}
                            {store.getprops("update") && ( // Assuming bulk assign needs update permission
                                <button
                                    className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
                                    onClick={() => handleBulkApprove(selectedRecords)}
                                >
                                    To Approve
                                </button>
                            )}
                            {store.getprops("delete") && ( // Assuming bulk delete needs delete permission
                                <button
                                    className="text-sm px-3 py-1 rounded-full border-2 border-primary bg-secondary text-primary transition hover:bg-primary hover:text-secondary"
                                    onClick={() => {
                                        const confirmBulkDelete = window.confirm(
                                            `Are you sure you want to delete ${selectedRecords.length} selected items?`
                                        );
                                        if (confirmBulkDelete) {
                                            handleBulkDelete(selectedRecords);
                                        }
                                    }}
                                >
                                    To Delete
                                </button>
                            )}
                        </div>
                    )} */}
                    {/* End of Integrated ListView Table Structure */}

                    <div className="float-right mr-8 mt-6">
                        <Pagination onchange={onpage} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TTask_AssignedUpd;
